import React from 'react'
import CategoryCarousal from './CategoryCarousal'

import useFetchPackageResult from './hooks/useFetchPackageResult';
import useFilterPackage from './hooks/useFilterPackage';
import PackageResultBlock from './PackageResultBlock';
import PackageSort from './PackageSort';
import FilterContainer from './FilterContainer';
import StaticPackageShimmer from './StaticPackageShimmer';
import NoResult from './NoResult';
import ResetAllFilter from './ResetAllFilter';

const PackageResult = () => {
    const { packageResult, isLoading } = useFetchPackageResult()
    const { filteredPackages, carousalCategory, handleSort, handleFilterChange, filters, handleCategoryFilter } = useFilterPackage(packageResult)


    if (isLoading) {
        return <StaticPackageShimmer />
    }

    if (packageResult.length == 0) {
        return <NoResult />
    }

    return (
        <section className="ContentArea">
            <div className="container">
                <CategoryCarousal carousalCategory={carousalCategory} handleCategoryFilter={handleCategoryFilter} />
                <div className="row spackgesrsltmain">
                    <FilterContainer packageResult={packageResult} handleFilterChange={handleFilterChange} filters={filters} />

                    <div className="Col_Result htlcol_Result">
                        <div className="htlresultListView">
                            <PackageSort handleSort={handleSort} />
                            {filteredPackages.length === 0 ? (
                                <ResetAllFilter handleFilterChange={handleFilterChange} />
                            ) : (
                                <PackageResultBlock
                                    packageResult={packageResult}
                                    filteredPackages={filteredPackages}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default PackageResult